module.exports = __webpack_public_path__ + "img/5.f61c6797.png";